import CustomSourceFlowText from "@/components/Shared/CustomSourceflowText";
import ArrowPurpleIcon from "@/assets/icons/arrow-purple.svg";
import useSolutions from "@/hooks/useSolutions";
import useLocale from "@/hooks/useLocale";
import localizePath from "@/functions/localizePath";
import styles from "./styles.module.scss";
import cn from "classnames";

export default function Solution({ solution, color, path }) {
  const locale = useLocale();
  const solutions = useSolutions();

  function filterData(solution) {
    return solutions.filter(({ url_slug }) => {
      switch (solution) {
        case "executive":
          return url_slug !== "learn-more-about-our-executive-search-solution";
        case "contingent":
          return url_slug !== "learn-about-our-contingent-solution";
        case "retained":
          return url_slug !== "learn-about-our-retained-search-solution";
        case "vacancy":
          return (
            url_slug !==
            "contact-us-for-more-information-if-you-re-unsure-what-your-next-steps-are"
          );
        default:
          return true;
      }
    });
  }

  return (
    <div className={cn(styles.Solution, "container pb-[90px]")}>
      <h2
        className={`text-3xl sm:text-[40px] xl:text-[50px]/[60px] max-w-[628px] w-full ${color}`}
      >
        <CustomSourceFlowText
          title="Looking for other hiring solutions"
          path={`dynamic1.${path}.solution1`}
          locale={locale}
        />
        <span className="text-pink">?</span>
      </h2>
      <p
        className={`max-w-[600px] mt-3 pb-10 text-sm sm:text-base md:text-lg lg:text-xl ${color}`}
      >
        <CustomSourceFlowText
          title="Supercharge your talent hiring. For our top tier clientele, we recommend this search option to achieve your toughest. Supercharge your talent hiring."
          path={`dynamic1.${path}.solution2`}
          locale={locale}
        />
      </p>
      <div className="w-full flex flex-wrap justify-center lg:justify-between gap-6 lg:flex-nowrap">
        {filterData(solution).map((elem) => (
          <div
            key={elem.id}
            className="card bg-purple relative h-[400px] max-w-[400px] lg:h-[660px] w-full cursor-pointer 3xl:max-w-[70%] transform transition-transform duration-300"
          >
            <a
              href={localizePath(elem?.url, locale)}
              className="group/item cursor-pointer"
            >
              <img
                src={elem.img}
                alt="solution"
                className="absolute w-full h-full"
              />
              <div className="p-6 xl:pt-[50px] xl:px-[55px]">
                <span className="text-white text-lg sm:text-xl/[24px] lg:text-2xl/3 xl:text-[30px]/[45px] relative z-10">
                  {elem.solution}
                </span>
              </div>
              <div className="w-[49px] h-[49px] text-[#1B0D34] bg-pink hidden group-hover/item:flex justify-center items-center absolute bottom-0 right-0">
                <ArrowPurpleIcon />
              </div>
            </a>
          </div>
        ))}
      </div>
    </div>
  );
}
